import { render, staticRenderFns } from "./ZipcodeDirectPopup.vue?vue&type=template&id=b1f64cbc&scoped=true&"
import script from "./ZipcodeDirectPopup.vue?vue&type=script&lang=js&"
export * from "./ZipcodeDirectPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f64cbc",
  null
  
)

export default component.exports